export const getVideoDevices = () => {
  let videoDevices = []

  if (navigator.mediaDevices) {
    return navigator.mediaDevices
      .enumerateDevices()
      .then(devices =>
        Promise.resolve(devices.filter(device => device.kind === 'videoinput'))
      )
  } else {
    return Promise.resolve(videoDevices)
  }
}
